const Schedule = (props) => {
  return (
    <section
      id={props.currentLang === "eng" ? "schedule" : "program-akisi"}
      className="w-full bg-[url(../../assets/images/schedule-bg.png)] bg-cover bg-top flex justify-center pt-32 pb-10 -mt-60"
    >
      <div data-aos="fade-up" className="w-4/5 max-w-screen-xl space-y-16 z-10">
        <div className="flex justify-center">
          <h4 className="text-green-custom font-bold text-4xl sm:text-5xl md:text-7xl text-center">
            {props.currentLang === "eng" ? "SCHEDULE" : "PROGRAM AKIŞI"}
          </h4>
        </div>
        <div className="w-full flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
          <div className="flex flex-col w-full md:w-1/2 space-y-2">
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  09.30-09.45
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Opening Ceremony"
                    : "Açılış Konuşması"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  09.45-10.00
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Welcome to BizzTrip"
                    : "BizzTrip'e Hoş Geldiniz!"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  10.00-10.20
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Unilever 101"
                    : "Unilever 101"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  10.20-10.50
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng" ? "Nutrition" : "Nutrition "}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  10.50-11.05
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Break with Knorr Çabuk"
                    : "Çabuk Bi’Mola!"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  11.05-11.35
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng" ? "Ice Cream" : "Ice Cream"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  11.35-12.05
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng" ? "Home Care" : "Home Care"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  12.05-12.20
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Break with Knorr Çabuk"
                    : "Çabuk Bi’Mola!"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  12.20-12.50
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Personal Care"
                    : "Personal Care"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  12.50-13.20
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Unilever Food Solution"
                    : "Unilever Food Solution"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  13.20-14.50
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Lunch Break with Knorr Çabuk"
                    : "Çabuk Yemek Vakti!"}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col w-full md:w-1/2 space-y-2">
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  14.50-15.20
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Beauty&Wellbeing"
                    : "Beauty&Wellbeing"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  15.20-15.50
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Inspiration Session"
                    : "İlham Verici Oturum"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  15.50-16.15
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Digital Transformation"
                    : "Dijital Dönüşüm "}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  16.15-16.30
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Break with Knorr Çabuk"
                    : "Çabuk Bi’Mola!"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  16.30-16.55
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Research&Development"
                    : "Ar&Ge"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  16.55-17.20
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Supply Chain"
                    : "Tedarik Zinciri"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  17.20-17.45
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Customer Business Development"
                    : "Müşteri İş Geliştirme"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  17.45-18.00
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Break with Knorr Çabuk"
                    : "Çabuk Bi’Mola!"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  18.00-18.30
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng" ? "UFLP Panel" : "UFLP Paneli"}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full">
              <div className="w-full md:w-1/3 bg-green-custom p-3">
                <p className="text-sm lg:text-xl text-white font-bold whitespace-nowrap">
                  18.30-18.45
                </p>
              </div>
              <div className="w-full md:w-2/3 bg-yellow-custom p-3">
                <p className="text-sm lg:text-xl text-green-custom font-medium">
                  {props.currentLang === "eng"
                    ? "Closing Ceremony"
                    : "Kapanış Konuşması"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;
